export const ERROR_CODES = {
  OLD_VERSION_WEB: 190,
  OLD_VERSION_IOS: 191,
  OLD_VERSION_ANDROID: 192,
  SERVER_MAINTENANCE: 193,
  OLD_MIN_VERSION_WEB: 210,
  OLD_MIN_VERSION_IOS: 211,
  OLD_MIN_VERSION_ANDROID: 212,

  PROMOTION_CODE_INVALID: 435,
  PROMOTION_EXPIRED: 436,
  PROMOTION_USAGE_LIMIT_REACHED: 437,
  DOWNGRADE_EXPIRED_PROMOTION: 438,
  INVALID_CLIENT_SUBSCRIPTION_STATUS: 439,
  PROMOTION_APPLICABLE_CLINIC_LIMIT_REACHED: 442,
  PROMOTION_ONLY_APPLY_TO_NEW_ACCOUNTS: 443,
  PROMOTION_NOT_ELIGIBLE_PLAN: 444,
  PROMOTION_NOT_ELIGIBLE_DURATION: 445,
  PROMOTION_NOT_ELIGIBLE_CLINIC: 446,
  PROMOTION_PER_CLINIC_LIMIT_REACHED: 447,
  PROMOTION_NOT_FOUND: 450,
  PROMOTION_ALREADY_INACTIVE: 452,
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;

export type HttpStatusCode =
  (typeof HTTP_STATUS_CODES)[keyof typeof HTTP_STATUS_CODES];
